import { createModel } from './utils.js';
import { mountShowHide } from './show-hide.js';
import conceptMap,      { parseHTML as parseConceptMap }      from './concept-map.js';
import flashcard,       { parseHTML as parseFlashcard }       from './flashcard.js';
import labeling,        { parseHTML as parseLabeling }        from './labeling.js';
import matching,        { parseHTML as parseMatching }        from './matching.js';
import multipleChoice,  { parseHTML as parseMultipleChoice }  from './multiple-choice.js';
import numericEntry,    { parseHTML as parseNumericEntry }    from './numeric-entry.js';
import ordering,        { parseHTML as parseOrdering }        from './ordering.js';
import predictThenCheck,{ parseHTML as parsePredictThenCheck }from './predict-then-check.js';

export { createModel, mountShowHide };

// Set theme variables on the document root.  Accepts up to five keys:
//   primary    — main color for buttons, active borders, highlights
//   background — widget background color
//   text       — text color
//   border     — border color
//   radius     — corner rounding (e.g. '4px', '0.5rem')
// Any key that is undefined is left unchanged.
export function setTheme({ primary, background, text, border, radius } = {}) {
  const root = document.documentElement;
  if (primary    !== undefined) root.style.setProperty('--forma-primary',    primary);
  if (background !== undefined) root.style.setProperty('--forma-bg',         background);
  if (text       !== undefined) root.style.setProperty('--forma-text',       text);
  if (border     !== undefined) root.style.setProperty('--forma-border',     border);
  if (radius     !== undefined) root.style.setProperty('--forma-radius',     radius);
}

export function renderConceptMap(el, config) {
  conceptMap.render({ model: createModel(config), el });
}

export function renderFlashcard(el, config) {
  flashcard.render({ model: createModel(config), el });
}

export function renderLabeling(el, config) {
  labeling.render({ model: createModel(config), el });
}

export function renderMatching(el, config) {
  matching.render({ model: createModel(config), el });
}

export function renderMultipleChoice(el, config) {
  multipleChoice.render({ model: createModel(config), el });
}

export function renderNumericEntry(el, config) {
  numericEntry.render({ model: createModel(config), el });
}

export function renderOrdering(el, config) {
  ordering.render({ model: createModel(config), el });
}

export function renderPredictThenCheck(el, config) {
  predictThenCheck.render({ model: createModel(config), el });
}

// Map each identifying CSS class to its [render, parseHTML] pair.
const WIDGETS = {
  'forma-concept-map':       [conceptMap.render,      parseConceptMap],
  'forma-flashcard':         [flashcard.render,       parseFlashcard],
  'forma-labeling':          [labeling.render,        parseLabeling],
  'forma-matching':          [matching.render,        parseMatching],
  'forma-multiple-choice':   [multipleChoice.render,  parseMultipleChoice],
  'forma-numeric-entry':     [numericEntry.render,    parseNumericEntry],
  'forma-ordering':          [ordering.render,        parseOrdering],
  'forma-predict-then-check':[predictThenCheck.render,parsePredictThenCheck],
};

// Find all widget divs under `root`, parse their HTML configuration, replace each
// div with the live rendered widget.  Defaults to scanning the whole document.
export function autoMount(root = document) {
  mountShowHide(root);
  for (const [cls, [render, parse]] of Object.entries(WIDGETS)) {
    root.querySelectorAll(`.${cls}`).forEach(div => {
      const container = document.createElement('div');
      div.replaceWith(container);
      render({ model: createModel(parse(div)), el: container });
    });
  }
}

// When loaded as a plain <script type="module"> tag, mount automatically.
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => autoMount());
  } else {
    autoMount();
  }
}
